<template>
    
    <div style="margin:40px" class="text-xs-center">
        <v-flex style="font-size:20px; padding:20px ">
            <label> ¿No puedes lavar tu ropa?</label> <br>
            <label> ¿No tienes mucho tiempo?</label>
        </v-flex>

        <v-layout class="hidden-lg-only hidden-xl-only" justify-center style="margin-top:40px">            
            <div style="border-radius:50%; height:200px; width:200px; overflow:hidden">
                <maps-conponent/>
            </div>
        </v-layout>
    </div>

</template>

<script>
// Import the EventBus we just created.
import { EventBus } from '../../../helpers/eventbus/event-bus.js'
import Maps from './Maps'
export default {
    data(){
        return{

        }
    },

    mounted(){

    },
    components: {
        'maps-conponent':Maps
    },
    methods: {
        openregistercompanymodal(){
            EventBus.$emit('companyregister')
        },
        
    }
}
</script>

